import {Settings} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import Environment from './Environment';

export const environment: FeatureObject = {
  type: 'settings',
  title: 'Environment',
  description: 'View backend environment keys and masked secret values (admin only)',
  path: '/settings/environment',
  component: (user) => <Environment user={user} />,
  IconComponent: Settings,
  status: FeatureStatus.ADMIN,
  tags: [],
  permission: 'owner',
};
